<div mat-dialog-content>
    <div class="mail-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-repMailNew (closeDialog)="onClose()" [mailId]="mailId"></app-repMailNew>
</div>